"use client";
import * as React from "react";
const SvgSendOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m1.53 2.36 5.72 2.5-5.73-.78zm5.72 6.78-5.73 2.5V9.92zM0 0v5.44L11.43 7 0 8.56V14l16-7z" }));
export {
  SvgSendOutlined as default
};
